"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactWaypoint = require("react-waypoint");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InView = function InView(_ref) {
  var onEnter = _ref.onEnter,
      topOffset = _ref.topOffset,
      bottomOffset = _ref.bottomOffset,
      children = _ref.children;
  return _react["default"].createElement(_reactWaypoint.Waypoint, {
    "data-test": "component-in-view",
    onEnter: onEnter,
    topOffset: topOffset,
    bottomOffset: bottomOffset
  }, _react["default"].createElement("div", null, children));
};

InView.defaultProps = {
  topOffset: '50%',
  bottomOffset: '40%'
};
var _default = InView;
exports["default"] = _default;